module.exports = __webpack_public_path__ + "static/Fallback04-dbcc3ca3484c85efcfc64fd2e3cb3e32.jpg";